import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from './store';
import Header from './layout/Header';
import Footer from './layout/Footer';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import NewRequest from "./pages/Request/NewRequest";
import TableOfRequest from "./pages/TableOfRequest";
import InventoryKala from "./pages/Kala/InventoryKala";
import './App.css';
import cookie from "../src/func/Cookie";
import Login from './layout/Login';
import UsersAccess from '../src/pages/UsersAccess';
import RequstList from '../src/pages/Request/RequestList';
import ReportKala from '../src/pages/Kala/ReportKala';
import ListKala from '../src/pages/Kala/ListKala';
import Backup from '../src/backup/Backup';
import About from './pages/About';
import RequestStatusList from './pages/Request/RequestStatusList'


//import history from './history'

const StatusNum = {
  prepishfactor: 5,
  pishfactor: 10,
  factor: 20,
  tahvil: 30,
  preafzayesh: 55,
  laghv: 40,
  afzayesh: 60,
}
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      LoginOpen: false,
      LoginState: (cookie.get("token") === "") ? false : true,
    }
    this.ShowLoginForm = this.ShowLoginForm.bind(this);
    this.SetLogin = this.SetLogin.bind(this);
  }
  async setstore() {
    console.log("hi");
    console.log(store.getState());
    store.dispatch({ type: 'INCREMENT' });
    console.log(store.getState());
    // await store.dispatch(() => console.log(store.getState()));

  }
  ShowLoginForm() {
    this.setState({ LoginOpen: !this.state.LoginOpen });

    //console.log(this.readTextFile(file)) ;
  }
  SetLogin() {
    (cookie.get("token") === "") ? this.setState({ LoginState: false }) : this.setState({ LoginState: true });
  }
  async componentDidMount() {
    //store.dispatch(()=>console.log(store.getState()));
  }
  render() {
    //store.dispatch(() => console.log(store.getState()));
    return (

      <Provider store={store}>
      <div>
        <Router>
          <div className="App">
            <button className="btn btn-outline-success" onClick={() => this.ShowLoginForm()} style={{ "backgroundColor": "#e3f2fd", 'marginLeft': '10px' }}>{(this.state.LoginOpen) ? "X" : "Login"}</button>
            <Login open={this.state.LoginOpen} SetLogin={this.SetLogin} />
            <Header />
            {!this.state.LoginState ? <h1>Login Please</h1> : <CustomLink />}
            <Footer />
          </div>
        </Router>
      </div>
      </Provider>

    );
  }
}
export default App;
const CustomLink = (props) => (
  <div>
    <Route exact path="/" component={() => <InventoryKala subpage='main' />} />
    <Route path="/about" component={() => <About />} />
    <Route path="/newrequest" component={() => <NewRequest progress={StatusNum.prepishfactor} />} />
    <Route path="/pishfactors" component={() => <RequestStatusList subpage='main' progress={StatusNum.pishfactor} nextprogress={StatusNum.factor} access={cookie.get("access")} />} />
    <Route path="/confirmfactors" component={() => <TableOfRequest subpage='main' progress={StatusNum.factor} nextprogress={StatusNum.tahvil} access={cookie.get("access")} />} />
    <Route path="/reports" component={() => <RequstList />} />
    <Route path="/reportkala" component={() => <ReportKala subpage='main' />} />
    <Route path="/increquest" component={() => <NewRequest progress={StatusNum.preafzayesh} />} />
    {(cookie.get("user") != "admin") ? null :
      <div>
        <React.Fragment>
          <Route path="/useraccess" component={() => <UsersAccess />} />
          <Route path="/kala" component={() => <ListKala />} />
          <Route path="/backup" component={() => <Backup />} />
        </React.Fragment>
      </div>
    }
  </div>
);


// WEBPACK FOOTER //
// ./src/App.js